<template>
  <div class="parent">
    <div class="head">

    </div>

    <div class="mid">
      <div class="time" v-text="obj.created_at">

      </div>

      <div class="contents" v-text="obj.message">

      </div>
    </div>

    <div class="foot">

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    data () {
      return {};
    },
    props: {
      obj: {
        type: Object
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .parent{
    padding-bottom: px2rem(37);
  }
  .head{
    background: url('../assets/img/parentRecord/top@2x.png') no-repeat 0 0;
    background-size: cover;
    width: px2rem(655);
    height: px2rem(16);
  }
  .mid{
    @include bg-img('../assets/img/parentRecord/rectangle');
    width: px2rem(655);
    height: 100%;
    line-height: px2rem(30);
    background-repeat: repeat-y;
    background-size: 100% 100%;
  }
  .foot{
  @include bg-img('../assets/img/parentRecord/bottom');
    width: px2rem(655);
    height: px2rem(38);
  }
  .time{
    padding-left: px2rem(20);
    float: left;
    width: px2rem(150);
    font-size: px2rem(28);
  }
  .contents{
    margin-right: px2rem(40);
    width: px2rem(396);
    line-height: 1.5;
    float: right;
    font-size: px2rem(28);
    word-break: break-all;
  }
  .mid:after{ display: block; clear:both; content: '';}

</style>



// WEBPACK FOOTER //
// VMyNew.vue?276086d3